
import axios from "../../axiosInstance";
import {
    USER_EVENTS_NEWS_REQUEST,
    USER_EVENTS_NEWS_SUCCESS,
    USER_EVENTS_NEWS_FAIL,
    CLEAR_ERRORS,
  } from "../constants/commonConstants";

// Fetch all user Events & News 
export const getUserEventsNews = () => async (dispatch) => {
  try {
    dispatch({ type: USER_EVENTS_NEWS_REQUEST });

    const { data } = await axios.get(
      "/api/v1/events-news/get-events-news"
    );

    dispatch({ type: USER_EVENTS_NEWS_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: USER_EVENTS_NEWS_FAIL, payload: error?.response?.data?.message });
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};